<template>
  <div class="services" id="services">
    <div class="services-section">
      <div class="inner-width">
        <h1 class="section-title">{{state.translation.services.title}}</h1>
        <div class="border-cust"></div>
        <div class="services-container">
          <div class="service-box">
            <div class="service-icon">
              <awesome-icon class="icon" :icon="['fas', 'paint-brush']"></awesome-icon>
            </div>
            <div class="service-title">{{state.translation.services.webdesign.title}}</div>
            <div class="service-desc">
              {{state.translation.services.webdesign.text}}
            </div>
          </div>
          <div class="service-box">
            <div class="service-icon">
              <awesome-icon class="icon" :icon="['fas', 'code']"></awesome-icon>
            </div>
            <div class="service-title">{{state.translation.services.webdevelopment.title}}</div>
            <div class="service-desc">
              {{state.translation.services.webdevelopment.text}}
            </div>
          </div>
          <div class="service-box">
            <div class="service-icon">
              <awesome-icon class="icon" :icon="['fab', 'wordpress']"></awesome-icon>
            </div>
            <div class="service-title">{{state.translation.services.wordpress.title}}</div>
            <div class="service-desc">
              {{state.translation.services.wordpress.text}}
            </div>
          </div>
          <div class="service-box">
            <div class="service-icon">
              <awesome-icon class="icon" :icon="['fab', 'js']"></awesome-icon>
            </div>
            <div class="service-title">{{state.translation.services.frontend.title}}</div>
            <div class="service-desc">
              {{state.translation.services.frontend.text}}
            </div>
          </div>
          <div class="service-box">
            <div class="service-icon">
              <awesome-icon class="icon" :icon="['fas', 'server']"></awesome-icon>
            </div>
            <div class="service-title">{{state.translation.services.backend.title}}</div>
            <div class="service-desc">
              {{state.translation.services.backend.text}}
            </div>
          </div>
          <div class="service-box">
            <div class="service-icon">
              <awesome-icon class="icon" :icon="['fab', 'android']"></awesome-icon>
            </div>
            <div class="service-title">{{state.translation.services.mobile.title}}</div>
            <div class="service-desc">
              {{state.translation.services.mobile.text}}
            </div>
          </div>
          <div class="service-box">
            <div class="service-icon">
              <awesome-icon class="icon" :icon="['fab', 'node-js']"></awesome-icon>
            </div>
            <div class="service-title">{{state.translation.services.services.title}}</div>
            <div class="service-desc">
              {{state.translation.services.services.text}}
            </div>
          </div>
          <div class="service-box">
            <div class="service-icon">
              <awesome-icon class="icon" :icon="['fas', 'shield-alt']"></awesome-icon>
            </div>
            <div class="service-title">{{state.translation.services.security.title}}</div>
            <div class="service-desc">
              {{state.translation.services.security.text}}
            </div>
          </div>
          <div class="service-box">
            <div class="service-icon">
              <awesome-icon class="icon" :icon="['fas', 'users-cog']"></awesome-icon>
            </div>
            <div class="service-title">{{state.translation.services.administration.title}}</div>
            <div class="service-desc">
              {{state.translation.services.administration.text}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Services',
  data() {
    return {
      state: this.$root.$data.state
    }
  }
}
</script>
